import { Divider, Skeleton } from '@gravity-ui/uikit';

import styles from '../styles.module.scss';

export const Loader = () => {
	return (
		<div>
			<div style={{ paddingBottom: '24px', paddingTop: '32px' }}>
				<Skeleton style={{ width: '400px', height: '28px' }} />
			</div>
			<div className={styles.blank_info}>
				<div className={styles.info}>
					<div className={styles.info__title}>
						<Skeleton style={{ width: '252px', height: '24px' }} />
					</div>

					<div className={styles.info__row}>
						<Skeleton style={{ width: '160px', height: '20px' }} />
						<Skeleton style={{ width: '334px', height: '20px' }} />
					</div>

					<div className={styles.info__row}>
						<Skeleton style={{ width: '160px', height: '20px' }} />
						<Skeleton style={{ width: '334px', height: '20px' }} />
					</div>

					<div className={styles.info__row}>
						<Skeleton style={{ width: '160px', height: '20px' }} />
						<Skeleton style={{ width: '334px', height: '20px' }} />
					</div>

					<div className={styles.info__row}>
						<Skeleton style={{ width: '160px', height: '20px' }} />
						<Skeleton style={{ width: '334px', height: '20px' }} />
					</div>
					<Divider />
					<div className={styles.info__row}>
						<Skeleton style={{ width: '160px', height: '20px' }} />
						<Skeleton style={{ width: '334px', height: '20px' }} />
					</div>
					<div className={styles.info__row}>
						<Skeleton style={{ width: '160px', height: '20px' }} />
						<Skeleton style={{ width: '334px', height: '20px' }} />
					</div>
					<div className={styles.info__row}>
						<Skeleton style={{ width: '160px', height: '20px' }} />
						<Skeleton style={{ width: '334px', height: '20px' }} />
					</div>
					<Divider />
					<div className={styles.info__row}>
						<Skeleton style={{ width: '160px', height: '20px' }} />
						<Skeleton style={{ width: '334px', height: '20px' }} />
					</div>
				</div>
				<div className={styles.info}>
					<div className={styles.info__title}>
						<Skeleton style={{ width: '252px', height: '24px' }} />
					</div>

					<div className={styles.info__row}>
						<Skeleton style={{ width: '160px', height: '20px' }} />
						<Skeleton style={{ width: '334px', height: '44px' }} />
					</div>

					<div className={styles.info__row}>
						<Skeleton style={{ width: '160px', height: '20px' }} />
						<Skeleton style={{ width: '334px', height: '20px' }} />
					</div>

					<div className={styles.info__row}>
						<Skeleton style={{ width: '160px', height: '20px' }} />
						<Skeleton style={{ width: '334px', height: '44px' }} />
					</div>
				</div>
			</div>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					paddingBottom: '16px',
				}}
			>
				<div>
					<Skeleton style={{ width: '109px', height: '24px' }} />
				</div>
				<div style={{ display: 'flex', gap: '16px' }}>
					<Skeleton style={{ width: '167px', height: '36px' }} />
					<Skeleton style={{ width: '167px', height: '36px' }} />
				</div>
			</div>
			<div className={styles.info} style={{ maxWidth: '1120px', width: '100%' }}>
				<div style={{ display: 'flex' }}>
					<div style={{ padding: '11px 31px 11px 8px' }}>
						<Skeleton style={{ width: '34px', height: '18px' }} />
					</div>
					<div style={{ padding: '11px 92px 11px 8px' }}>
						<Skeleton style={{ width: '80px', height: '18px' }} />
					</div>
					<div style={{ padding: '11px 119px 11px 8px' }}>
						<Skeleton style={{ width: '133px', height: '18px' }} />
					</div>
					<div style={{ padding: '11px 8px 11px 13.4px' }}>
						<Skeleton style={{ width: '74px', height: '18px' }} />
					</div>
					<div style={{ padding: '11px 8px 11px 13.4px' }}>
						<Skeleton style={{ width: '74px', height: '18px' }} />
					</div>
					<div style={{ padding: '11px 8px 11px 13.4px' }}>
						<Skeleton style={{ width: '74px', height: '18px' }} />
					</div>
					<div style={{ padding: '11px 8px 11px 13.4px' }}>
						<Skeleton style={{ width: '74px', height: '18px' }} />
					</div>
					<div style={{ padding: '11px 8px 11px 13.4px' }}>
						<Skeleton style={{ width: '74px', height: '18px' }} />
					</div>
					<div style={{ padding: '11px 8px 11px 13.4px' }}>
						<Skeleton style={{ width: '74px', height: '18px' }} />
					</div>
				</div>
				<Divider />
				<div style={{ display: 'flex' }}>
					<div style={{ display: 'flex' }}>
						<div style={{ padding: '11px 44px 11px 8px' }}>
							<Skeleton style={{ width: '21px', height: '18px' }} />
						</div>
						<div style={{ padding: '11px 22px 11px 8px' }}>
							<Skeleton style={{ width: '150px', height: '18px' }} />
						</div>
						<div
							style={{
								padding: '11px 20px 11px 8px',
								display: 'flex',
								flexDirection: 'column',
								gap: '8px',
							}}
						>
							<Skeleton style={{ width: '232px', height: '18px' }} />
							<Skeleton style={{ width: '232px', height: '18px' }} />
							<Skeleton style={{ width: '111px', height: '18px' }} />
						</div>
					</div>
					<div style={{ display: 'flex', flexDirection: 'column', paddingTop: '5px' }}>
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<div style={{ paddingLeft: '8px', paddingTop: '4px' }}>
								<Skeleton style={{ width: '82px', height: '18px' }} />
							</div>
							<div style={{ display: 'flex' }}>
								<div style={{ padding: '11px 8px 11px 63.4px' }}>
									<Skeleton style={{ width: '24px', height: '18px' }} />
								</div>
								<div style={{ padding: '11px 8px 11px 63.4px' }}>
									<Skeleton style={{ width: '24px', height: '18px' }} />
								</div>
								<div style={{ padding: '11px 8px 11px 63.4px' }}>
									<Skeleton style={{ width: '24px', height: '18px' }} />
								</div>
								<div style={{ padding: '11px 8px 11px 63.4px' }}>
									<Skeleton style={{ width: '24px', height: '18px' }} />
								</div>
								<div style={{ padding: '11px 8px 11px 63.4px' }}>
									<Skeleton style={{ width: '24px', height: '18px' }} />
								</div>
								<div style={{ padding: '11px 8px 11px 63.4px' }}>
									<Skeleton style={{ width: '24px', height: '18px' }} />
								</div>
							</div>
						</div>
						<Divider />
						<div style={{ display: 'flex', flexDirection: 'column', paddingTop: '5px' }}>
							<div style={{ paddingLeft: '8px', paddingTop: '4px' }}>
								<Skeleton style={{ width: '82px', height: '18px' }} />
							</div>
							<div style={{ display: 'flex' }}>
								<div style={{ padding: '11px 8px 11px 63.4px' }}>
									<Skeleton style={{ width: '24px', height: '18px' }} />
								</div>
								<div style={{ padding: '11px 8px 11px 63.4px' }}>
									<Skeleton style={{ width: '24px', height: '18px' }} />
								</div>
								<div style={{ padding: '11px 8px 11px 63.4px' }}>
									<Skeleton style={{ width: '24px', height: '18px' }} />
								</div>
								<div style={{ padding: '11px 8px 11px 63.4px' }}>
									<Skeleton style={{ width: '24px', height: '18px' }} />
								</div>
								<div style={{ padding: '11px 8px 11px 63.4px' }}>
									<Skeleton style={{ width: '24px', height: '18px' }} />
								</div>
								<div style={{ padding: '11px 8px 11px 63.4px' }}>
									<Skeleton style={{ width: '24px', height: '18px' }} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
